import { BaseService } from '../base/BaseService';
export class ProjectBaselineService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectBaselineService.DEFAULT_SERVICE_PATH,
            basePath: ProjectBaselineService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** POST /api/projects/{projectId}/baselines — capture a new baseline snapshot. */
    async capture(projectId, request) {
        const response = await this.captureRaw(projectId, request);
        return response.data ?? null;
    }
    captureRaw(projectId, request) {
        return this.http.post(this.buildUrl(`${projectId}/baselines`), request);
    }
    /** GET /api/projects/{projectId}/baselines — all baselines for the project (newest first). */
    async getByProject(projectId) {
        const response = await this.getByProjectRaw(projectId);
        return response.data ?? [];
    }
    getByProjectRaw(projectId) {
        return this.http.get(this.buildUrl(`${projectId}/baselines`));
    }
    /** GET /api/projects/{projectId}/baselines/{baselineId} — a single baseline. */
    async getById(projectId, baselineId) {
        const response = await this.getByIdRaw(projectId, baselineId);
        return response.data ?? null;
    }
    getByIdRaw(projectId, baselineId) {
        return this.http.get(this.buildUrl(`${projectId}/baselines/${baselineId}`));
    }
    /** GET /api/projects/{projectId}/baselines/{baselineId}/compare — variance vs current state. */
    async compare(projectId, baselineId) {
        const response = await this.compareRaw(projectId, baselineId);
        return response.data ?? null;
    }
    compareRaw(projectId, baselineId) {
        return this.http.get(this.buildUrl(`${projectId}/baselines/${baselineId}/compare`));
    }
    /** PATCH /api/projects/{projectId}/baselines/{baselineId}/activate — make it the active baseline. */
    activate(projectId, baselineId) {
        return this.http.patch(this.buildUrl(`${projectId}/baselines/${baselineId}/activate`), {});
    }
    /** DELETE /api/projects/{projectId}/baselines/{baselineId} — delete a baseline (and its items). */
    remove(projectId, baselineId) {
        return this.http.delete(this.buildUrl(`${projectId}/baselines/${baselineId}`));
    }
}
ProjectBaselineService.DEFAULT_SERVICE_PATH = 'projects';
ProjectBaselineService.BASE_PATH = 'api/projects';
//# sourceMappingURL=ProjectBaselineService.js.map